<div class="banner">
  @if (isMenu===true) {
    <table class="title">
      <tr>
        @if (menu.category.id !== 0 && menu.category.title != '') {
          <td>
            <div class="menu category">{{menu.category.title.toUpperCase()}}</div>
          </td>
        }
        @if (menu.category.id !== 0 && menu.category.title != '') {
          <td>
            <div class="menu divider">></div>
          </td>
        }
        <td>
          <div class="menu" [ngClass]="{'menu-bold': menu.category.id !== 0  && menu.category.title != ''}">{{menu.item.title.toUpperCase()}}</div>
        </td>
      </tr>
    </table>
  }

  <!-- <div class="welcome > menu-open" *ngIf="isMenu===true">
  <span *ngIf="user!==''">Welcome {{user}}</span>
</div> -->

@if (isMenu===false) {
  <table class="title">
    <tr>
      <td>
        <div class="menu-bold">{{report.title.toUpperCase()}}</div>
      </td>
    </tr>
  </table>
}

@if (isMenu===true && menu.item.id === 100) {
  <table class="count">
    <tr>
      @if (getUserLastLoginDate() !== '') {
        <td width=200px>
          <div>Last login: {{getUserLastLoginDate() | shortDateTime}}</div>
        </td>
      }
      <td>
        <div>Favorites: {{count}}</div>
      </td>
    </tr>
  </table>
}

@if (isMenu===true && lessThan(menu.item.id, 100)) {
  <table class="count">
    <tr>
      <td>
        <div>{{count}} @if (count!=='1') {
          <span>dashboards</span>
          }@if (count==='1') {
          <span>dashboard</span>
        }</div>
      </td>
    </tr>
  </table>
}

@if (isMenu===false) {
  <table class="last-view">
    <tr>
      <td width=200px>
        <div>Last viewed: {{report.lastViewed | shortDateTime}}</div>
      </td>
      <td>
        <div>Data refreshed: <span (click)="onRefreshDateClick()" class="link">{{getDataRefreshDate() | shortDateTime}}</span></div>
      </td>
    </tr>
  </table>
}

@if (isMenu===false) {
  <div class="button-container">
    <table>
      <tr>
        <td>
          <button class="button rate" mat-button (click)="rateReport()">RATE</button>
        </td>
        <td>
          <button class="button close-report" mat-button (click)="closeReport()">CLOSE</button>
        </td>
      </tr>
    </table>
  </div>
}

</div>
<app-rater [report]="report"></app-rater>
<app-dataset-viewer></app-dataset-viewer>